import { useCallback, useContext, useState } from 'react';
import { BackendDispatchContext } from '../context/backend-context';
import { BaseError, FeatureFlag } from '@nimey/podcast-global-entity';

export const useRemoveUserFeature = (flag: FeatureFlag, userId: string) => {
  const [ loading, setLoading ] = useState<boolean>(false);
  const [ lastError, setError ] = useState<BaseError>();
  const { asyncActions } = useContext(BackendDispatchContext)

  const remove = useCallback(async () => {
    setLoading(true);
    try {
      await asyncActions!.removeUserFeature(flag, userId)
      setLoading(false);
    } catch(e) {
      setError(e as BaseError);
    }
    setLoading(false);
    return undefined;
  }, [flag, userId, asyncActions])


  return {
    loading,
    lastError,
    remove
  };
}